window.__assetPrefix__ = 'https://fe-static-dev.hkgai.net/meeting-ai-fe-web/18369';